import { addDays, endOfMonth, endOfQuarter } from 'date-fns';
import { CalculationFrequency } from 'modules/BenchmarkForm';

type getNextFromDateProps = {
  timeWindow: Record<string, any>;
  calculationFrequencyId: CalculationFrequency;
  fields: any[];
};

export const getNextFromDate = ({
  timeWindow,
  calculationFrequencyId,
  fields,
}: getNextFromDateProps) => {
  const mostRecentTimeWindow = fields.reduce(
    (a, c: any) => {
      if (!a.fromDate || new Date(c.fromDate) > new Date(a.fromDate)) {
        a = c;
      }
      return a;
    },
    { fromDate: '' } as any
  );

  switch (calculationFrequencyId) {
    case CalculationFrequency.day:
      return {
        ...timeWindow,
        fromDate: addDays(mostRecentTimeWindow.fromDate || new Date(), 1),
      };
    case CalculationFrequency.month:
      return {
        ...timeWindow,
        fromDate: endOfMonth(
          addDays(mostRecentTimeWindow.fromDate || new Date(), 1)
        ),
      };
    case CalculationFrequency.quarter:
      return {
        ...timeWindow,
        fromDate: endOfQuarter(
          addDays(mostRecentTimeWindow.fromDate || new Date(), 1)
        ),
      };
    default:
      return {
        ...timeWindow,
        fromDate: endOfMonth(
          addDays(mostRecentTimeWindow.fromDate || new Date(), 1)
        ),
      };
  }
};
